import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
// Our components
import { LoginPage } from 'pages/Login.page';
import { NewPasswordPage } from 'pages/NewPassword.page';
import { NotFoundPage } from 'pages/404.page';
import { PrivateRoute } from 'containers/PrivateRoute';
import { ResetPasswordPage } from 'pages/ResetPassword.page';
import { Signuppage } from 'pages/Signup.page';
import Layout from 'containers/DefaultLayout/Layout';

const AppRoutes = () => {
    return (
        <BrowserRouter>
            <Switch>
                <Route exact path="/" component={LoginPage} />
                <Route path="/login" render={() => <Redirect to="/" />} />
                <Route path="/reset" component={ResetPasswordPage} />
                <Route path="/signup" component={Signuppage} />
                <Route path="/newpassword" component={NewPasswordPage} />
                <PrivateRoute path="/r" component={Layout} />
                <Route path="*" component={NotFoundPage} />
            </Switch>
        </BrowserRouter>
    );
};

export default AppRoutes;
